import * as React from 'react';
import { useState } from 'react';

export const Slider = () => {
	const [currentSlide, setCurrentSlide] = useState(0);

	const setSlide = (activeSlide: number) => {
		setCurrentSlide(activeSlide);
	};

	return (
		<section className="card-slider">
			<div className="slider">
				<div className="slide" style={{ transform: `translateX(${100 * (0 - currentSlide)}%)` }}>
					<div className="slide-wrapper">
						<p className="label">SECURE</p>
						<h2>Complete Access Control</h2>
						<ul>
							<li>
								Permissions assigned to roles - Give rights to roles and assign those roles to
								users.
							</li>
							<li>Row Level Security - Define who can access which rows</li>
							<li>Column Level Security - Only authorised users can see columns and fields.</li>
						</ul>
					</div>
				</div>
				<div className="slide" style={{ transform: `translateX(${100 * (1 - currentSlide)}%)` }}>
					<div className="slide-wrapper">
						<p className="label">FAST</p>
						<h2>Speed Up Development</h2>
						<ul>
							<li>
								Code Generator - Introspect a database and instantly create the Typescript resolvers
							</li>
							<li>
								Instant GraphQL API - Connect your data sources to Graphweaver for an instant
								GraphQL API including filters, sorting, and pagination arguments. This API includes
								all the CRUD operations you would expect.
							</li>
						</ul>
					</div>
				</div>
				<div className="slide" style={{ transform: `translateX(${100 * (2 - currentSlide)}%)` }}>
					<div className="slide-wrapper">
						<p className="label">SIMPLE</p>
						<h2>Reduces complexity, all your data in one place</h2>
						<ul>
							<li>Define your GraphQL types and resolvers using TypeScript classes</li>
							<li>Leverage the power of Graphweaver's built in decorators and type annotations</li>
							<li>Complete flexibility over your code and where it is deployed</li>
						</ul>
					</div>
				</div>
			</div>

			<div className="slider-nav">
				<a onClick={() => setSlide(0)} className={currentSlide === 0 ? 'active' : undefined}>
					Secure<span></span>
				</a>
				<a onClick={() => setSlide(1)} className={currentSlide === 1 ? 'active' : undefined}>
					Fast<span></span>
				</a>
				<a onClick={() => setSlide(2)} className={currentSlide === 2 ? 'active' : undefined}>
					Simple<span></span>
				</a>
			</div>
		</section>
	);
};
